import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex flex-wrap gap-[8px]"
};
const _hoisted_2 = ["onClick"];
export default /*@__PURE__*/_defineComponent({
  __name: 'Tag',
  props: {
    tags: {
      default: () => []
    },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tags, tag => {
        return _openBlock(), _createElementBlock("span", {
          key: tag.value,
          class: _normalizeClass(["tag mb-2 border-[2px] border-solid px-2 leading-6 text-[12px] rounded-[4px] cursor-pointer transition-colors duration-200", _ctx.modelValue === tag.value ? 'border-[#846af7] text-[#846af7] bg-[#f0edff] dark:bg-[#2d284d] dark:text-[#c5b9f7] dark:border-[#846af7]' : 'border-[#d0d0d0] text-[#666666] bg-[#f5f5f5] hover:border-[#846af7] hover:text-[#846af7] dark:border-[#555555] dark:text-[#cccccc] dark:bg-[#3a3a3a] dark:hover:border-[#846af7] dark:hover:text-[#c5b9f7]']),
          onClick: $event => emits('update:modelValue', tag.value)
        }, _toDisplayString(tag.label), 11, _hoisted_2);
      }), 128))]);
    };
  }
});